import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';

function AdmissionPolicy() {
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Students Corner › Admission Policy</p>
                <h1>Admission Policy</h1>
                <p>Transparent and merit-based admissions as per SPPU and Government norms.</p>
            </div>
            <div className="page-content">
                <div className="info-card">
                    <h2>General Admission Criteria</h2>
                    <ul>
                        <li>Admission is open to candidates who have passed their 10+2 or equivalent examination.</li>
                        <li>Admission to B.A. and B.Sc. is based on 12th (HSC) marks merit.</li>
                        <li>Reservation policy as per Maharashtra Government norms is strictly followed.</li>
                        <li>Candidates from SC, ST, OBC, NT, SBC, and EWS categories must submit valid caste certificates.</li>
                    </ul>
                </div>
                <div className="info-card">
                    <h2>Reservation Policy</h2>
                    <table className="data-table">
                        <thead><tr><th>Category</th><th>Reservation %</th></tr></thead>
                        <tbody>
                            {[['SC', '13%'], ['ST', '7%'], ['VJNT', '11%'], ['OBC', '19%'], ['SBC', '2%'], ['EWS', '10%'], ['Persons with Disability (PwD)', '3%'], ['Open Merit', 'Remaining seats']].map(([c, p]) => <tr key={c}><td>{c}</td><td>{p}</td></tr>)}
                        </tbody>
                    </table>
                </div>
                <div className="info-card">
                    <h2>Required Documents</h2>
                    <ul>
                        <li>10th (SSC) Marksheet & Certificate</li>
                        <li>12th (HSC) Marksheet & Certificate</li>
                        <li>School/College Leaving Certificate</li>
                        <li>Caste Certificate (if applicable)</li>
                        <li>Non-Creamy Layer Certificate (for OBC)</li>
                        <li>Income Certificate (for scholarship)</li>
                        <li>Migration Certificate (if from another board/university)</li>
                        <li>Aadhar Card copy</li>
                        <li>Passport-size photographs (4 copies)</li>
                    </ul>
                </div>
                <div className="info-card">
                    <h2>Admission Process</h2>
                    <a href="/admission-process" className="ext-link-chip">📋 View Full Admission Process</a>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default AdmissionPolicy;
